module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Find the Invisible Cow")]), _vm._v(" "), _c('p', [_vm._v("Move your cursor around to find the cow. It’s hiding behind the shouting.")]), _vm._v(" "), _c('div', {
    staticClass: "audio-warning"
  }, [_c('div', {
    staticClass: "audio-warning__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.image.speaker)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "auto-warning__text"
  }, [_vm._v("Make sure you turn your audio on before playing.")])]), _vm._v(" "), (!_vm.audioPlayer.loaded) ? _c('div', {
    staticClass: "loading-bar"
  }, [_c('div', {
    staticClass: "loading-bar-inner",
    style: (("width:" + (_vm.audioPlayer.loadedAmount * 100) + "%;"))
  })]) : _vm._e(), _vm._v(" "), (_vm.audioPlayer.loaded) ? _c('div', {
    staticClass: "start-button"
  }, [_c('find-button', {
    on: {
      "click": function($event) {
        _vm.setPage(_vm.PAGE_GAME)
      }
    }
  }, [_vm._v("\n      Start Game\n    ")])], 1) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "note"
  }, [_vm._v("\n    If you do not hear anything, it’s possible that your browser does not support the Web Audio\n    API. Currently supported browsers are\n    "), _c('a', {
    attrs: {
      "href": "http://google.com/chrome",
      "target": "_blank"
    }
  }, [_vm._v("Chrome 10+")]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": "http://www.mozilla.org/en-US/firefox/new/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox 25+")]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": "http://www.opera.com/",
      "target": "_blank"
    }
  }, [_vm._v("Opera 15+")]), _vm._v(", and\n    "), _c('a', {
    attrs: {
      "href": "http://www.apple.com/au/safari/",
      "target": "_blank"
    }
  }, [_vm._v("Safari 6+")]), _vm._v(".\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-546b77d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 163
// module chunks = 2